        <!-- BEGIN: Header -->
        <!-- BEGIN: Header -->
        <div class="z-[9]" [class.hidden]="!dashcodeHelper.Settings.isSmallScreen || dashcodeHelper.Settings.menuIsOpen" id="app_header">
          <div
          class="app-header z-[999] ltr:ml-[248px] rtl:mr-[248px] bg-white dark:bg-slate-800 shadow-sm dark:shadow-slate-700" [class.margin-0]="dashcodeHelper.Settings.isSmallScreen">
            <div class="flex justify-between items-center h-full">
              <div class="flex items-center md:space-x-4 space-x-2 xl:space-x-0 rtl:space-x-reverse vertical-box">
                <a [routerLink]="['/']" class="mobile-logo inline-block"
                [class.xl:hidden]="dashcodeHelper.Settings.isSmallScreen && dashcodeHelper.Settings.menuIsOpen">
                  <img src="assets/images/2023/logo-mobile.png" class="black_logo" alt="logo">
                  <img src="assets/images/2023/logo-mobile.png" class="white_logo" alt="logo">
                </a>
                <button class="smallDeviceMenuController hidden md:inline-block" (click)="dashcodeHelper.menuToggle()"
                [class.xl:hidden]="dashcodeHelper.Settings.isSmallScreen && dashcodeHelper.Settings.menuIsOpen">
                  <iconify-icon
                    class="leading-none bg-transparent relative text-xl top-[2px] text-slate-900 dark:text-white"
                    icon="heroicons-outline:menu-alt-3"></iconify-icon>
                </button>
                <!-- <button class="flex items-center xl:text-sm text-lg xl:text-slate-400 text-slate-800 dark:text-slate-300 px-1
          rtl:space-x-reverse search-modal" data-bs-toggle="modal" data-bs-target="#searchModal">
                  <iconify-icon icon="heroicons-outline:search"></iconify-icon>
                  <span class="xl:inline-block hidden ml-3">Search...
                  </span>
                </button> -->

              </div>
              <!-- end vertcial -->
              <div class="items-center space-x-4 rtl:space-x-reverse horizental-box">
                <a [routerLink]="['/']" >
                  <span class="xl:inline-block hidden">
                    <img src="assets/images/2023/logo.png" class="black_logo " alt="logo">
                    <img src="assets/images/2023/logo.png" class="white_logo" alt="logo">
                  </span>
                  <span class="xl:hidden inline-block">
                    <img src="assets/images/2023/logo.png" class="black_logo " alt="logo">
                    <img src="assets/images/2023/logo.png" class="white_logo " alt="logo">
                  </span>
                </a>
                <button class="smallDeviceMenuController  open-sdiebar-controller xl:hidden inline-block" (click)="dashcodeHelper.menuToggle()">
                  <iconify-icon
                    class="leading-none bg-transparent relative text-xl top-[2px] text-slate-900 dark:text-white"
                    icon="heroicons-outline:menu-alt-3"></iconify-icon>
                </button>

              </div>
              <!-- end horizental -->



              <!-- end top menu -->
              <div class="nav-tools flex items-center lg:space-x-5 space-x-3 rtl:space-x-reverse leading-0">

                <!-- Language -->

                <dashlayout-header-toggletheme></dashlayout-header-toggletheme>

                <!-- grayScale -->

                <!-- Message -->

                <!-- Notifications  -->

                <!-- BEGIN: Profile Dropdown -->
                <!-- Profile DropDown Area -->
                <dashlayout-header-profile></dashlayout-header-profile>
                <!-- END: Header -->
                <button class="smallDeviceMenuController md:hidden block leading-0" (click)="dashcodeHelper.menuToggle()">
                  <iconify-icon class="cursor-pointer text-slate-900 dark:text-white text-2xl"
                    icon="heroicons-outline:menu-alt-3"></iconify-icon>
                </button>
                <!-- end mobile menu -->
              </div>
              <!-- end nav tools -->
            </div>
          </div>
        </div>

        <!-- BEGIN: Search Modal -->
        <!-- <div class="modal fade fixed top-0 left-0 hidden w-full h-full outline-none overflow-x-hidden overflow-y-auto"
          id="searchModal" tabindex="-1" aria-labelledby="searchModalLabel" aria-hidden="true">
          <div class="modal-dialog relative w-auto pointer-events-none top-1/4">
            <div
              class="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white dark:bg-slate-900 bg-clip-padding rounded-md outline-none text-current">
              <form>
                <div class="relative">
                  <input type="text" class="form-control !py-3 !pr-12" placeholder="Search">
                  <button
                    class="absolute right-0 top-1/2 -translate-y-1/2 w-9 h-full border-l text-xl border-l-slate-200 dark:border-l-slate-600 dark:text-slate-300 flex items-center justify-center">
                    <iconify-icon icon="heroicons-solid:search"></iconify-icon>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div> -->
        <!-- END: Search Modal -->
        <!-- END: Header -->
        <!-- END: Header -->
